package app.footyguide.web.route

/**
 * Deterministic navigation stack for SPA client-side history.
 * Guarantees in-app Back button always transitions screens deterministically
 * without getting stuck in browser history desync.
 */
object WebNavigationStack {
    private val history = mutableListOf<String>()

    fun init(initialPath: String) {
        if (history.isEmpty()) {
            history.add(clean(initialPath))
        }
    }

    fun push(path: String) {
        val c = clean(path)
        if (history.isEmpty() || history.last() != c) {
            history.add(c)
        }
    }

    fun pop(): String? {
        if (history.size > 1) {
            history.removeLast()
            return history.last()
        }
        return null
    }

    fun clear() {
        history.clear()
    }

    fun current(): String? = history.lastOrNull()

    private fun clean(path: String): String {
        return if (path.startsWith("/")) path else "/$path"
    }
}
